import { z } from "zod";

export const reviewOfSystemsValidation = z.object({
  unit: z.enum(["Imperial", "Metric"]),
  height: z.object({
    feet: z.string().nullable().optional(),
    inches: z.string().nullable().optional(),
    cm: z.string().nullable().optional(),
  }),
  weight: z.object({
    pounds: z.string().nullable().optional(),
    kg: z.string().nullable().optional(),
  }),
  recentSymptoms: z.array(z.string()).optional(),
  accidentRelated: z.object({
    date: z.string(),
    accidentInsurance: z.string().optional(),
    employer: z.string().optional(),
    accident: z.string(),
  }).optional(),
});

export default reviewOfSystemsValidation;